import { authApiCall } from '../auth/saga';

export const getCustomerProfile = () =>
  authApiCall({
    url: '/users/customer-profile/',
    method: 'get',
  });

export const saveFcmToken = (token) =>
  authApiCall({
    url: '/users/update-firebase-fcm/',
    method: 'post',
    data: { token },
  });
